import { PrimitiveAtom, useAtom } from 'jotai';
import React, { useCallback, useState } from 'react';

export const useBooleanState = (initialValue: boolean): [boolean, () => void, () => void] => {
    const [value, setValue] = useState(initialValue);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    return [value, setTrue, setFalse];
};

export const useBooleanStateAtom = (
    atom: PrimitiveAtom<boolean>,
): [boolean, () => void, () => void] => {
    const [value, setValue] = useAtom<typeof atom>(atom);
    const setTrue = useCallback(() => setValue(true), [setValue]);
    const setFalse = useCallback(() => setValue(false), [setValue]);
    return [value, setTrue, setFalse];
};

export const useStateWithDerivedBoolean = <Value,>(
    initialValue: Value | null,
): [Value | null, React.Dispatch<React.SetStateAction<Value | null>>, boolean, () => void] => {
    const [value, setValue] = useState(initialValue);
    const isTrue = !!value;
    const setNull = useCallback(() => setValue(null), []);
    return [value, setValue, isTrue, setNull];
};
